import Axois from '../utils/axios'
import EventEmitter from '../utils/eventEmitter';



export const loadAnalyticPlans = async () => {
  let response = await Axois.get('/analytic-plans').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
    const responseData = await response.data;
    return responseData;
  // return [];
}


export const loadAnalyticPlan = async (action) => {
  try {
    switch (action) {
      case 'new':
        let requests = await Axois.get('/setups/analytic-plans');
        const responseData = await requests.data;
        return {...responseData, plan: {}};
        // return { positions: [], budgets: [], analytic: {}};
      
      default:
        let response = await Axois.get('/analytic-plans/'+action);
        const responseJson = await response.data;
        console.log(responseJson)
        return responseJson;
        // return { positions: [], budgets: [], analytic: {}};
    }
  }catch (err) {
    console.log(err);
  }
}



const useAnalyticPlan = () => {
  
  const save = async (data, success) => {
    try {
      const response = await Axois.post('/analytic-plans', data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('analytic_plan_response', data.seo);
    }catch(err) {
      console.log(err);
    }
  };


  const update = async (seo, data, success) => {
    try {
      const response = await Axois.put('/analytic-plans/'+seo, data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('analytic_plan_response', data.seo);
    }catch (err) {
      console.log(err);
    }
  }

  return { save, update };
}


export default useAnalyticPlan;